var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C14.6 1.66667 18.3334 5.40001 18.3334 10C18.3334 14.6 14.6 18.3333 10 18.3333C5.40002 18.3333 1.66669 14.6 1.66669 10C1.66669 5.40001 5.40002 1.66667 10 1.66667ZM5.01945 12.8469C6.24238 14.6724 8.07928 15.8333 10.1331 15.8333C12.1869 15.8333 14.0239 14.6724 15.2468 12.8469C13.9071 11.5977 12.1094 10.8333 10.1331 10.8333C8.15686 10.8333 6.35915 11.5977 5.01945 12.8469ZM10 9.16667C11.3808 9.16667 12.5 8.04738 12.5 6.66667C12.5 5.28596 11.3808 4.16667 10 4.16667C8.61927 4.16667 7.50002 5.28596 7.50002 6.66667C7.50002 8.04738 8.61927 9.16667 10 9.16667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleFill);
export default __webpack_public_path__ + "static/media/account-circle-fill.1441ac3b3b7351a3d857b3fce4d5f552.svg";
export { ForwardRef as ReactComponent };